export default __webpack_public_path__ + "static/media/fullstack.2762618e.jpg";